import jsPDF from "jspdf";
// import "jspdf-autotable";

const printAgendaPDF = (selectedAgenda) => {
  // unpack everything you passed in:
  const {
    committeeName = "",
    committeeCode = "",
    location = "",
    meetingTime,
    scheduledBills = [],
    agendaItems = [],
    publicParticipation = false,
  } = selectedAgenda;

  // PDF setup (portrait A4)
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "pt",
    format: "a4",
  });

  // full page width (used for centering)
  const pageWidth = doc.internal.pageSize.width;

  // margins
  const leftMargin = 40;
  const rightMargin = 40;
  const topMargin = 20;
  const bottomMargin = 40;

  // header drawer (called after pages are finished)
  const addHeader = (doc, pageNumber, totalPages) => {
    const headerHeight = 15;
    const headerColor = [103, 137, 127]; 

    const contentWidth = doc.internal.pageSize.width - leftMargin - rightMargin;

    doc.setFillColor(...headerColor);
    doc.rect(leftMargin, topMargin, contentWidth, headerHeight, "F");

    doc.setFont("helvetica", "normal");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(9);

    const agendaText = `2025 Montana Legislature - 69th Regular Session  Printed: ${new Date().toLocaleDateString(
      "en-US",
      {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      }
    )} ${new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}   Page ${pageNumber} of ${totalPages}`;

    const agendaTextWidth = doc.getTextWidth(agendaText);
    const centerX = leftMargin + contentWidth / 2;
    doc.text(agendaText, centerX - agendaTextWidth / 2, topMargin + 12);
  };

  // cursor / y-position
  let cursorY = topMargin + 40;

  // --- Title block ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  const titleText = committeeName || "";
  let tw = doc.getTextWidth(titleText);
  doc.text(titleText, (pageWidth - tw) / 2, cursorY);

  // Location
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  cursorY += 20;
  const locText = location || "";
  tw = doc.getTextWidth(locText);
  doc.text(locText, (pageWidth - tw) / 2, cursorY);

  // Date / Time
  cursorY += 18;
  const whenText = meetingTime
    ? new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      }).format(new Date(meetingTime))
    : "TBD";
  tw = doc.getTextWidth(whenText);
  doc.text(whenText, (pageWidth - tw) / 2, cursorY);

  // advance down to start the next section
  cursorY += 30;

  // --- Scheduled Bills ---
  doc.setFont("helvetica", "bold");
   doc.setFontSize(12);
   doc.text("Scheduled Bills", leftMargin, cursorY);
   cursorY += 20;
   doc.setFont("helvetica", "normal");

   if (scheduledBills.length) {
     scheduledBills.forEach((b, i) => {
       const sponsor = b.sponsor
         ? `${b.sponsor.lastName}, ${b.sponsor.firstName}`
         : "Unknown";
 
       // build the line: "1. HB 52: Short Title – Sponsor"
       const line = `\u2022 ${b.billType.code} ${b.billNumber}: ${b.draft.shortTitle} – ${sponsor}`;
 
       doc.setFontSize(10);
       doc.text(line, leftMargin, cursorY);
       cursorY += 14;
 
       // handle page break if needed
       if (cursorY > doc.internal.pageSize.height - bottomMargin) {
         doc.addPage();
         cursorY = topMargin + 20;
       }
     });
   } else {
     doc.setFontSize(10);
     doc.text("None", leftMargin, cursorY);
     cursorY+= 14;
   }
 
   // add some breathing room before the next section
   cursorY += 16;

  // --- Other Agenda Items ---
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("Other Agenda Items", leftMargin, cursorY);
  cursorY += 20;
  doc.setFont("helvetica", "normal");

  if (agendaItems.length) {
    agendaItems.forEach((item) => {
      // bullet: "• Title: Description"
      const line = `\u2022 ${item.title}: ${item.description}`;
      doc.setFontSize(10);
      doc.text(line, leftMargin, cursorY);
      cursorY += 14;

      // page break when you hit bottom
      if (cursorY > doc.internal.pageSize.height - bottomMargin) {
        doc.addPage();
        cursorY = topMargin + 20;
      }
    });
  } else {
    doc.setFontSize(10);
    doc.text("\u2022 None", leftMargin, cursorY);
    cursorY += 14;
  }

  // space before Notes
  cursorY += 16;

  // --- Notes ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Notes", leftMargin, cursorY);
  doc.setFont("helvetica", "normal");
  doc.text(
    `\u2022 Accepting Online Public Comment: ${publicParticipation ? "Yes" : "No"}`,
    leftMargin,
    cursorY + 18
  );

  // add header to each page
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    addHeader(doc, i, totalPages);
  }

// build a timestamped filename: MM-DD-YYYY-HH-MM-CODE.pdf
  const dt = new Date(meetingTime || Date.now());
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const d = String(dt.getDate()).padStart(2, "0");
  const hh = String(dt.getHours()).padStart(2, "0");
  const mm = String(dt.getMinutes()).padStart(2, "0");
  const fileName = `${m}-${d}-${y}-${hh}-${mm}-${committeeCode || "Agenda"}.pdf`;

  doc.save(fileName);
};

export default printAgendaPDF;
